import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface StyledProps {
  hasList?: boolean;
}

export const Container = styled.div.attrs<any, StyledProps>((): any => ({}))`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ hasList }) => (hasList ? 116 : 0)}px;

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: ${({ hasList }) => (hasList ? 75 : 0)}px;
  }
`;

export const List = styled.ol`
  display: flex;

  @media ${({ theme }) => theme.device.mobile} {
    flex-direction: column;
    align-items: center;
  }

  @media ${({ theme }) => theme.device.desktop} {
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`;

export const HeaderEdit = styled.button`
  font-weight: 600;
  text-align: right;
  color: ${({ theme }) => theme.primaryBackgroundColor};
  cursor: pointer;
  background: ${ColorPalette.Transparent};

  @media ${({ theme }) => theme.device.mobile} {
    position: absolute;
    right: 24px;
    top: 28px;
  }
`;

export const SubTitle = styled.span`
  font-weight: 600;
  font-size: 12px;
  text-align: right;
  color: ${({ theme }) => theme.primaryBackgroundColor};
  cursor: pointer;
  background: ${ColorPalette.Transparent};
  text-align: center;
  margin: 20px 15px 10px 0px;
  text-align: right;
`;

export const LoadingContainer = styled.div`
  display: flex;
  margin: auto;

  @media ${({ theme }) => theme.device.desktop} {
    height: 100%;
  }
`;
